var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user && (_vm.user.first_name || _vm.user.last_name))?_c('div',{staticClass:"avatar text-avatar mx-auto flex-none"},[_c('span',[_vm._v(_vm._s(_vm.user.first_name.charAt(0))+" "+_vm._s(_vm.user.last_name.charAt(0)))])]):_c('div',{staticClass:"avatar text-avatar mx-auto flex-none"},[_c('span',[_vm._v("sts")])])
}
var staticRenderFns = []

export { render, staticRenderFns }